import React, { useState } from 'react'

import { RiContactsBook2Fill, RiPencilFill, RiCheckFill } from 'react-icons/ri'

import WhiteBox from 'components/atoms/WhiteBox'
import useUserInfo from 'hooks/useUserInfo'
import useUpdateUserProfile from 'services/firebase/hooks/users/useUpdateUserProfile'

const Contacts = () => {
  const [userInfo] = useUserInfo()
  const [edit, setEdit] = useState(false)
  const doUpdateUserProfile = useUpdateUserProfile()
  const [value, setValue] = useState(userInfo.phone)
  const handleEdit = () => {
    if (edit) {
      if (value !== userInfo.phone) {
        doUpdateUserProfile({
          phone: value,
        })
      }
      setEdit(false)
    } else {
      setEdit(true)
    }
  }

  return (
    <WhiteBox
      withOpacity
      title='Contact'
      icon={<RiContactsBook2Fill />}
      actions={
        <button
          onClick={handleEdit}
          type='button'
          className={edit ? '-editing' : ''}
        >
          {edit ? <RiCheckFill /> : <RiPencilFill />}
        </button>
      }
    >
      {edit ? (
        <input disabled type='text' value={userInfo.email} />
      ) : (
        <span>{userInfo.email}</span>
      )}
      {edit ? (
        <input
          type='text'
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      ) : (
        <span>{value}</span>
      )}
    </WhiteBox>
  )
}

export default Contacts
